export default __webpack_public_path__ + "static/arley_lego-d851ce819e003e8288a8cce61b995a0e.png";